module.exports = __webpack_public_path__ + "static/media/background-mobile.4d063dbf.jpg";